import InviteUser from '@/modules/profile/InviteUser'

export default function InviteUserScreen() {
  return <InviteUser />
}
